import React, { Component } from "react";
import PropTypes from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";

class RecipientRelationship extends Component {
  constructor(props) {
    super(props);

    this.RelationshipOptions = [
      { name: "Self", val: 6 },
      { name: "Spouse/Partner", val: 1 },
      { name: "Child", val: 4 },
      { name: "Grandchild", val: 7 },
      { name: "Parent", val: 2 },
      { name: "Grandparent", val: 3 },
      { name: "Sibling", val: 5 },
      { name: "Other", val: 9 },
    ];
  }

  static defaultProps = {
    element: {
      name: "relationship",
      prefix: "pf-recipient-",
      id: "pf-recipient-relationship",
      labelText: "Patient is my",
      colLabelClassName: "label",
      colFieldClassName: "field",
      colValidationClassName: "messaging",
    },
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 3 },
      3: { sm: 12, lg: 6 },
    },
  };

  handleChange = (ev) => {
    const { onEventCallback, fieldMetadata } = this.props;

    fieldMetadata.value = ev.target.value;
    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, {
        value: ev.target.value,
        isValid: true,
        status: "",
      });
    }
  };

  render() {
    const { colLayout, element, fieldMetadata } = this.props;

    return (
      <Row className={element.id}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label htmlFor={element.id}>{element.labelText}</label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <select
            key={fieldMetadata.value}
            id={element.id}
            name={element.name}
            className={fieldMetadata.status}
            onChange={this.handleChange}
            defaultValue={fieldMetadata.value}
          >
            {this.RelationshipOptions.map(({ name, val }) => {
              return (
                <option key={val} value={val}>
                  {name}
                </option>
              );
            })}
          </select>
        </Col>
        <Col
          className={element.colValidationClassName}
          width={colLayout[3]}
        ></Col>
      </Row>
    );
  }
}

RecipientRelationship.propTypes = {
  colLayout: PropTypes.object.isRequired,
  element: PropTypes.object.isRequired,
  onEventCallback: PropTypes.func,
  fieldMetadata: PropTypes.object.isRequired,
};

export default RecipientRelationship;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');